import {
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import type { RoleWithPermissions } from '@library/types/role';
import { UserKebabMenu } from '@library/components/menus/kebabMenu/UserKebabMenu';
import type { UserRoleMenuActions } from '@library/components/menus/kebabMenu/UserKebabMenu';

export interface RolesRowProps {
  menuActions: UserRoleMenuActions;
  role: RoleWithPermissions;
}

export const RolesRow = ({ menuActions, role }: RolesRowProps) => {
  return (
    <div className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user text-2xs relative flex items-center border-b xl:text-xs">
      <PlayerProfile
        className="flex w-1/3 items-center p-3"
        name={role.name}
        subheader={`${role.userCount} users assigned`}
      >
        <div className="flex flex-col">
          <PlayerName className="font-heebo text-soClean-100 block text-sm font-medium capitalize tracking-tight" />
          <PlayerSubheader className="text-soClean-170 font-heebo block text-xs font-medium tracking-tight" />
        </div>
      </PlayerProfile>

      <div className="flex w-1/6 items-center p-3">
        <span className="bg-soFresh-130 text-soClean-130 whitespace-nowrap rounded-2xl px-3 py-2 leading-tight">
          {role.permissionIds.length}
        </span>
      </div>

      <p className="flex w-1/2 p-3">{role.description}</p>

      <div className="absolute right-2">
        <UserKebabMenu
          deleteMessage="Delete role"
          editMessage="Edit role details"
          menuActions={menuActions}
          id={role.id}
        />
      </div>
    </div>
  );
};
